var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Group } from '@/models/Group';
import { debounce } from 'lodash';
import { cloneDeep } from 'lodash';
let StudentSelector = class StudentSelector extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.groupClone = {};
        this.selectedAll = false;
        this.selectedStudents = {};
        this.searchInput = '';
        this.searchDebounce = this.handleSearch();
        this.isLoading = true;
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        this.groupClone = cloneDeep(this.group);
        this.groupClone.users = this.group.getStudents();
        this.sortStudents(this.groupClone);
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    sortStudents(group) {
        if (!group || !group.users) {
            return;
        }
        group.users.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    }
    handleSearch() {
        return debounce((searchInput) => {
            if (!this.group) {
                return;
            }
            if (!this.groupClone || !this.groupClone.users) {
                return;
            }
            this.groupClone.users = this.group.getStudents().filter((student) => {
                return student.name.toLowerCase().includes(searchInput.toLowerCase());
            });
        }, 400);
    }
    onSelectStudent(student, selected) {
        if (!this.multiple) {
            this.handleSingleSelect(student, selected);
            return;
        }
        this.$set(this.selectedStudents, student.id, selected);
        this.$nextTick(() => {
            this.selectedAll = this.hasSelectedAllStudents;
        });
    }
    handleSingleSelect(student, selected) {
        this.$set(this, 'selectedStudents', {});
        if (selected) {
            this.$set(this.selectedStudents, student.id, selected);
        }
    }
    onToggleSelectAll(selected) {
        if (!this.groupClone || !this.groupClone.users) {
            return;
        }
        // Important: Update the property first, then update the individual selections
        this.selectedAll = selected;
        // Set all visible students to the selected state
        this.groupClone.users.forEach((student) => {
            this.$set(this.selectedStudents, student.id, selected);
        });
    }
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    get hasSelectedAllStudents() {
        if (!this.groupClone || !this.groupClone.users || this.groupClone.users.length === 0) {
            return false;
        }
        return this.groupClone.users.every((student) => {
            return this.selectedStudents[student.id] === true;
        });
    }
    get selectAllText() {
        return this.hasSelectedAllStudents ? this.$tc('Unselect all') : this.$tc('Select all');
    }
    // #endregion
    // #region @Watchers
    onHasSelectedAllStudentsChange(value) {
        this.selectedAll = value;
    }
    onSelectedStudentsChange(value) {
        this.$emit('update:selectedStudents', value);
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], StudentSelector.prototype, "group", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], StudentSelector.prototype, "multiple", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], StudentSelector.prototype, "canSelectAll", void 0);
__decorate([
    Watch('hasSelectedAllStudents'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], StudentSelector.prototype, "onHasSelectedAllStudentsChange", null);
__decorate([
    Watch('selectedStudents', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], StudentSelector.prototype, "onSelectedStudentsChange", null);
StudentSelector = __decorate([
    Component({})
], StudentSelector);
export default StudentSelector;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
